import {transform} from 'ol/proj';
import {MultiPolygon} from 'ol/geom';
import Feature from 'ol/Feature';

/**
 * Function to generate a Feature Multipolygon
 *
 * @param {Array} coordinatesArray
 * @param {String} projection
 * @param {String} toProjection
 *
 * @return {Feature}
 */
export default function(coordinatesArray, projection = 'EPSG:25830', toProjection = 'EPSG:25830') {
  const coords = coordinatesArray.map((arrayCoords) => {
    return arrayCoords.map((coordinate) => {
      const {lon, lat} = coordinate;
      return transform([lon, lat], projection, toProjection);
    });
  });
  return new Feature({
    geometry: new MultiPolygon([coords]),
  });
}
